import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, memo, useMemo } from 'react';
import { Grid } from '@chakra-ui/react';
import { isGroupedRow } from '../../SimpleTable.utils';
import { TableGroupedRow } from './components/TableGroupedRow';
import { TableRow } from './components/TableRow';
const TableBodyFC = ({ columns, rows, noBg, readonly, errors, onValueChange }) => {
    const templateColumns = useMemo(() => {
        return (columns || [])
            .map((col) => {
            return col.width ?? `minmax(90px, ${col.columnTemplate ?? '1fr'})`;
        })
            .join(' ');
    }, [columns]);
    return (_jsx(Grid, { templateColumns: templateColumns, children: rows.map((row, rowId) => {
            return (_jsx(Fragment, { children: isGroupedRow(row) ? (_jsx(TableGroupedRow, { noBg: noBg, rowId: rowId, row: row, isReadOnly: !!readonly, errors: errors, columns: columns, onValueChange: (...args) => onValueChange?.(...args, rowId) })) : (_jsx(TableRow, { noBg: noBg, rowId: rowId, row: row, isReadOnly: !!readonly, errors: errors, onValueChange: onValueChange, columns: columns })) }, row.key ?? rowId));
        }) }));
};
export const TableBody = memo(TableBodyFC);
//# sourceMappingURL=TableBody.js.map